import React, { Suspense } from "react";
import { connect } from "react-redux";
import withRouter from "../../HOC/withRouter";
import Loader from "../../components/Loader";
import { Mainmenu } from "../../components";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  authActionCreators,
  userActions,
  clientActions,
  categoryActions,
  brandActions,
  marketGoalActions,
  touchPointActions,
  orgaActions,
  quizActions,
  dailyQuestActions,
  surveyActions,
} from "../../store/actions";
import { compose } from "react-recompose";
import ReactGA from "react-ga";
import { promisify } from "../../utils/promisify";
import StyleSetter from "../../components/layout/styleSetter";
import { journeyActions } from "../../store/journeys/actions";
import { journeyChannelsActions } from "../../store/journeyChannels/actions";
import ClientHeader from "../../components/ClientHeader";
import { get } from "lodash";
import ChallengesFeedbackModal from "../ChallengesFeedbackModal";
import DailyQuestModal from "../DailyQuestModal";
import ViewProfile from "../ViewProfile";
import Routes from "./Routes";

const LOGIN_PAGES_PATHS = ["/login", "/sso/process"];

class MainLayout extends React.Component {
  state = {
    searchText: "",
    isPdf: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.location !== this.props.location) {
      if (LOGIN_PAGES_PATHS.includes(this.props.location.pathname)) {
        this.updateWorkspaceinfo();
      }
    }

    if (nextProps.profile && nextProps.profile._id !== this.props.profile?._id) {
      const isSsoUserWithHash = this.isSsoUserWithHash(nextProps.profile);
      const isWelcomePage = this.props.location.pathname.includes("/welcome");
      if (isSsoUserWithHash && !isWelcomePage) {
        this.setState({ isRedirecting: true });
        this.props.navigate(`/welcome/${nextProps.profile.hash}`);
      }
    }
  }

  componentWillMount() {
    this.setState({ startTimestamp: Date.now() });
  }

  getProfileAndClient = () => {
    promisify(this.props.getProfile, {})
      .then(res => {
        if (!res.email) {
          this.props.logout();
          return;
        }
      })
      .catch(err => {
        this.props.logout();
      });
  };
  componentDidUpdate = prevProps => {
    if (prevProps.isAuthenticated !== this.props.isAuthenticated && this.props.isAuthenticated) {
      this.getProfileAndClient();
    }

    if (this.props.location.pathname !== prevProps.location.pathname) {
      ReactGA.pageview(window.location.pathname + window.location.search);
      ReactGA.set({ dimension1: localStorage.getItem("clientId") });
      ReactGA.set({ dimension2: localStorage.getItem("clientName") });
    }

    if (this.props.client && prevProps.client && this.props.client._id !== prevProps.client._id) {
      this.updateWorkspaceinfo();
      caches &&
        caches.keys().then(function (names) {
          for (let name of names) caches.delete(name);
        });
    }
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    ReactGA.pageview(window.location.pathname + window.location.search);
    this.updateWorkspaceinfo();
    const url = new URL(window.location.href);
    const isPdf = url.searchParams.get("isPDF") === "true";
    this.setState({ isPdf });
  }

  updateWorkspaceinfo = () => {
    if (this.props.isAuthenticated) {
      this.getProfileAndClient();
      promisify(this.props.getCategories, {});
      promisify(this.props.getMarketGoals, {});
      promisify(this.props.getTouchPoints, {});
      promisify(this.props.getClient, {}).then(() => {
        promisify(this.props.getColumns, {});
        promisify(this.props.getTasks, {});
        promisify(this.props.getQuiz, {});
        promisify(this.props.getSurvey, {});
        promisify(this.props.getJourneys, {});
        promisify(this.props.getJourneyChannels, {});
        promisify(this.props.getUsers);
        promisify(this.props.getAuditTouchPoints, {});
        if (this.props.client && this.props.client.showDailyQuest) {
          promisify(this.props.getDailyQuest, {});
        }
      });
      ReactGA.set({ dimension1: localStorage.getItem("clientId") });
      ReactGA.set({ dimension2: localStorage.getItem("clientName") });
    }
  };

  handleSearchText = e => {
    if (e.keyCode === 13) this.props.navigate("/searchresult");
    this.setState({ searchText: e.target.value });
  };

  handleClearSearchText = () => {
    this.setState({ searchText: "" });
  };

  handleGoback = () => {
    this.props.navigate(-1);
  };

  isSsoUserWithHash = profile => {
    return !!(profile?.ssoEnabled && profile?.hash && !profile?.password);
  };

  render() {
    const { isAuthenticated, client, profile } = this.props;
    const isSsoUserWithHash = this.isSsoUserWithHash(profile);
    const showMainLayout = isAuthenticated && !isSsoUserWithHash;
    const style = showMainLayout
      ? {
          display: "grid",
          gridTemplateColumns: "auto minmax(1px, 1fr)",
        }
      : {};

    return (
      <div className="App">
        <StyleSetter client={client} />
        <div style={style}>
          {showMainLayout && client && <Mainmenu />}
          <div className="page-wrapper">
            {showMainLayout && client && (
              <ClientHeader
                client={client}
                profile={profile}
                showFeeds={true}
                showLogins={get(this.props, "profile.otherLogins", []).length > 1}
              />
            )}
            <Suspense
              fallback={
                <div
                  style={{
                    display: "flex",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "70vh",
                  }}
                >
                  <Loader color={client?.primaryColor} />
                </div>
              }
            >
              <Routes client={client} handleGoback={this.handleGoback} profile={this.props.profile} />
            </Suspense>
          </div>
        </div>

        {this.props.user.challengeModalVisible && (
          <ChallengesFeedbackModal
            tasks={this.props.user.challengeModalData}
            challengeModalVisible={this.props.user.challengeModalVisible}
            closeModal={this.props.hideChallengeModal}
          />
        )}
        {this.props.dailyQuest.questModalVisible && !this.state.isPdf && (
          <DailyQuestModal
            quest={this.props.dailyQuest.questData}
            questModalVisible={this.props.dailyQuest.questModalVisible}
            closeModal={this.props.hideDailyQuestModal}
            answerQuest={this.props.answerDailyQuest}
            showQuestAnimation={this.props.showQuestAnimation}
            client={this.props.client}
          />
        )}
        {this.props.user.userProfileVisible && this.props.user.selectedUserId && (
          <ViewProfile userId={this.props.user.selectedUserId} />
        )}
        <ToastContainer
          position="top-right"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnVisibilityChange
          draggable
          pauseOnHover
        />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isAuthenticated: state.auth.isAuthenticated,
  profile: state.user.profile,
  categories: state.category.categories,
  brands: state.brand.brands,
  marketGoals: state.marketGoal.marketGoals,
  touchPoints: state.touchPoint.touchPoints,
  client: state.client.client,
  user: state.user,
  dailyQuest: state.dailyQuest,
});

export default compose(
  withRouter,
  connect(mapStateToProps, authActionCreators),
  connect(null, userActions),
  connect(null, clientActions),
  connect(null, categoryActions),
  connect(null, brandActions),
  connect(null, marketGoalActions),
  connect(null, touchPointActions),
  connect(null, orgaActions),
  connect(null, quizActions),
  connect(null, surveyActions),
  connect(null, journeyActions),
  connect(null, journeyChannelsActions),
  connect(null, dailyQuestActions),
)(MainLayout);
